export const DISTRIBUTIONS_WHAT_IF_KEY = 4;
export const DISTRIBUTIONS_WHAT_IF_PATH = 'WhatIfRetirementDistributions';
